import { inject, injectable } from "inversify";
import { SERVICES_TYPES } from "@/ioc/SERVICES_TYPES";
import { HttpClient } from "@/services/client";
import { MetaRate, MetaRatePayload, MetaRatesImportResult } from "@/models/pricing";
import { IPricingApi } from "./IPricingApi";

@injectable()
export class PricingApi implements IPricingApi {
  @inject(SERVICES_TYPES.HTTP_CLIENT)
  private client: HttpClient;

  private readonly baseUrl = "/admin/pricing/rates";

  async getRates(): Promise<MetaRate[]> {
    const { data } = await this.client.get<MetaRate[]>(this.baseUrl);
    return data;
  }

  async upsertRate(payload: MetaRatePayload): Promise<MetaRate> {
    const { data } = await this.client.put<MetaRate>(this.baseUrl, payload);
    return data;
  }

  async removeRate(id: string): Promise<void> {
    await this.client.delete(`${this.baseUrl}/${id}`);
  }

  async importRates(file: string, effectiveFrom: string): Promise<MetaRatesImportResult> {
    const { data } = await this.client.post<MetaRatesImportResult>(`${this.baseUrl}/import`, {
      file,
      effectiveFrom
    });
    return data;
  }
}
